/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * City list
 */
export interface CityResult { 
    /**
     * Country ISO Alpha2 code. Examples: ES, GB...
     */
    countryCode?: string;
    /**
     * Region code. Examples: Z, CU...
     */
    regionCode?: string;
    /**
     * City code. Examples: ZARAGOZA, CUENCA...
     */
    cityCode?: string;
    /**
     * City name. Examples: Zaragoza, Cuenca...
     */
    name?: string;
}

